/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Section4_P2Inputs */

const en_privacy_section4_p2 = /** @type {(inputs: Privacy_Section4_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No other third-party analytics, tracking, or data collection services are used on this site.`)
};

const ko_privacy_section4_p2 = /** @type {(inputs: Privacy_Section4_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이 사이트에서는 다른 제3자 분석, 추적 또는 데이터 수집 서비스를 사용하지 않습니다.`)
};

const ja_privacy_section4_p2 = /** @type {(inputs: Privacy_Section4_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`このサイトでは、他のサードパーティの分析、トラッキング、データ収集サービスは使用していません。`)
};

/**
* | output |
* | --- |
* | "No other third-party analytics, tracking, or data collection services are used on this site." |
*
* @param {Privacy_Section4_P2Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const privacy_section4_p2 = /** @type {((inputs?: Privacy_Section4_P2Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Section4_P2Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_privacy_section4_p2(inputs)
	if (locale === "ko") return ko_privacy_section4_p2(inputs)
	return ja_privacy_section4_p2(inputs)
});